import { render, staticRenderFns } from "./NavbarWalletStatusIcon.vue?vue&type=template&id=ba28e3ae&scoped=true"
import script from "./NavbarWalletStatusIcon.vue?vue&type=script&lang=ts"
export * from "./NavbarWalletStatusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba28e3ae",
  null
  
)

export default component.exports